export default {
      id: "plus-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "sprite.svg#plus-usage",
      toString: function () {
        return this.url;
      }
    }